
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external-page",
      function () {
        return require("private-next-pages/external-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external-page"])
      });
    }
  